export const saveStoreUser = (data) => ({
    type: 'USER_SAVE',
    data: data
})

export const signOutStoreUser = () => ({
    type: 'USER_SIGNOUT'
})